// Include jQuery plugins
//require('jquery.sample');

// Import non-jQuery modules
//const sample = require('sample');

// Define wp_localize_script handles
/* global simpleParallax, handorgel */

(function($) {
    const wntrTheme = {
        body: $('body'),
        html: $('html'),
        document: $(document),
        initLoaded: false,

        /**
         * Initialise theme JS on page load
         */
        init: function() {
            // Do we have JS?
            $('html').removeClass('no-js');

            // Automatically call all methods that start with __, in the order they're defined
            for(const prop in wntrTheme) {
                if(prop.startsWith('__') && typeof wntrTheme[prop] === 'function') {
                    wntrTheme[prop].call();
                }
            }
        },

        __handleAccordions: function() {
            wntrTheme.body.find('.accordions__intro-description-toggle').on('click', function() {
                $(this).toggleClass('accordions__intro-description-toggle--active');
                $(this).closest('.accordions__intro').find('.accordions__intro-description-foldable').toggleClass('accordions__intro-description-foldable--active');
            });

            if(wntrTheme.body.find('.handorgel')) {
                $.each(wntrTheme.body.find('.handorgel'), function() {
                    new handorgel($(this)[0], {});
                });
            }
        },

        __handleParallaxBanner: function() {
            const image = document.getElementsByClassName('image__banner-image');
            new simpleParallax(image, {
                //delay: 0,
                //orientation: 'down',
                //scale: 1.3,
                //overflow: true,
                //customContainer: '.container',
                //customWrapper: '.wrapper'
            });
        },

        /*
        * Video banner handler
        */
        __videoBannerHandler: function() {
            const play = wntrTheme.body.find('.video__banner-play');

            if(play.length) {
                play.on('click', function() {
                    const player = $(this).siblings('.video__banner-player');
                    if(player.length && player.hasClass('is-hidden')) {
                        player.removeClass('is-hidden');
                        const iframe = player.children('iframe');
                        const iframeSrc = $(iframe).attr('src');
                        iframe.prop('src', iframeSrc + '&autoplay=1&showinfo=0&showsearch=0&rel=0&modestbranding=1');
                        iframe.find('.ytp-button').trigger();
                    }
                });
            }
        },

        /*
        * Handle sidebar links effect
        */
        __handleSidebarLinks: () => {
            const blocks = wntrTheme.body.find('.block-heading');
            const links = wntrTheme.body.find('.sidebar-link');
            $(document).scroll(function() {
                if($(window).width() > 1024) {
                    blocks.each(function() {
                        if($(document).scrollTop() >= $(this).offset().top - 21) {
                            links.removeClass('is-active');
                            $("a[href*=" + $(this).attr('id') + "]").addClass('is-active');
                        }

                        if($(window).scrollTop() + $(window).height() === $(document).height()) {
                            links.removeClass('is-active');
                            links.last().addClass('is-active');
                        }
                    });
                }
            });

            if($(window).width() > 1024) {
                if($(window).scrollTop() <= 0) {
                    links.first().addClass('is-active');
                }
                links.on('click', function() {
                    $(this).addClass('is-active');
                });
            }
        },

        /*
        * Read more handler
        */
        __readMoreHandler: function() {
            const toggle = wntrTheme.body.find('.btn--toggle-more');
            const content = wntrTheme.body.find('.agenda__block-text');
            const bullets = wntrTheme.body.find('.bullet__block ul');

            bullets.each(function() {
                if($(this).innerHeight() >= 250) {
                    $(this).addClass('has-toggle-content');
                    $(this).siblings('.btn--toggle-more').addClass('is-visible');
                }
            });

            content.each(function() {
                if($(this).innerHeight() >= 500) {
                    $(this).addClass('has-toggle-content');
                    $(this).siblings('.btn--toggle-more').addClass('is-visible');
                }
            });

            if(toggle.length) {
                toggle.on('click', function() {
                    if(!$(this).hasClass('is-toggled')) {
                        $(this).siblings('.has-toggle-content').addClass('is-toggled');
                        $(this).addClass('is-toggled').attr('aria-expanded', 'true');
                    } else {
                        $(this).siblings('.has-toggle-content').removeClass('is-toggled');
                        $(this).removeClass('is-toggled').attr('aria-expanded', 'false');
                    }
                });
            }
        },

        /*
        * SoMe handler
        */
        __someHandler: function() {
            const toggleInstagram = wntrTheme.body.find('.some__action--instagram');
            const toggleFacebook = wntrTheme.body.find('.some__action--facebook');
            const instagram = wntrTheme.body.find('.some__instagram');
            const facebook = wntrTheme.body.find('.some__facebook');

            toggleInstagram.on('click', () => {
                facebook.removeClass('is-active');
                instagram.addClass('is-active');
                toggleInstagram.addClass('is-active').attr('aria-selected', 'true');
                toggleFacebook.removeClass('is-active').attr('aria-selected', 'false');
            });
            toggleFacebook.on('click', () => {
                instagram.removeClass('is-active');
                facebook.addClass('is-active');
                toggleFacebook.addClass('is-active').attr('aria-selected', 'true');
                toggleInstagram.removeClass('is-active').attr('aria-selected', 'false');
            });
        },

        /*
        * Smooth scroll
        */
        __smoothScrolling: function() {
            $('a[href^="#"]').click(function(event) {
                event.preventDefault();

                $('html, body').animate({
                    scrollTop: $(String($.attr(this, 'href'))).offset().top - 20
                }, 500);
                return false;
            });
        },

        /*
        * Facetwp
        */
        __facetwp: function() {
            document.addEventListener('facetwp-refresh', function() {
                toggleFacets();
            });

            document.addEventListener('facetwp-loaded', function() {
                toggleFacets();
                wntrTheme.body.find('.candidates__grid--all').removeClass('is-loading');
                wntrTheme.body.find('.candidates__municipality--all').removeClass('is-loading');
            });

            function toggleFacets() {
                wntrTheme.body.find('.candidates__grid--all').addClass('is-loading');
                wntrTheme.body.find('.candidates__municipality--all').addClass('is-loading');
                if(wntrTheme.initLoaded) {
                    const selectorValue = $('.facetwp-facet-kommun').find('.fs-label').text();
                    wntrTheme.body.find('.candidates__municipality--all').text(selectorValue);
                    if(selectorValue === "Alla kommuner") {
                        wntrTheme.body.find('.candidates__municipality--all').hide();
                        wntrTheme.body.find('.candidates__grid--all').addClass('is-hidden');

                        wntrTheme.body.find('.candidates__municipality--single').show();
                        wntrTheme.body.find('.candidates__grid--single').show();
                    } else {
                        wntrTheme.body.find('.candidates__municipality--single').hide();
                        wntrTheme.body.find('.candidates__municipality--all').show();
                        wntrTheme.body.find('.candidates__grid--all').removeClass('is-hidden');
                        wntrTheme.body.find('.candidates__grid--single').hide();
                    }

                }
                wntrTheme.initLoaded = true;
            }
        },

        /**
         * Mobile menu toggle
         */
        __toggleMobileMenu: function() {
            const menuBtn = wntrTheme.body.find('.hamburger');
            const headerEl = wntrTheme.body.find('.header');
            const navWrapper = wntrTheme.body.find('.site__navigation-wrapper');
            const menuHeading = wntrTheme.body.find('.menu-item-has-children');

            const isMobileNav = function() {
                return $(window).width() <= 1024;
            };

            const openMobileNav = function() {
                menuBtn.addClass('is-active').attr('aria-expanded', 'true');
                headerEl.addClass('active-header');
                wntrTheme.body.addClass('body--fixed');
                navWrapper.find('a, button').filter(':visible').first().trigger('focus');
            };

            const closeMobileNav = function() {
                menuBtn.removeClass('is-active').attr('aria-expanded', 'false');
                headerEl.removeClass('active-header');
                wntrTheme.body.removeClass('body--fixed');
                menuBtn.trigger('focus');
            };

            menuBtn.on('click', function() {
                if(headerEl.hasClass('active-header')) {
                    closeMobileNav();
                } else {
                    openMobileNav();
                }
            });

            // Trap focus inside the off-canvas mobile nav while it's open, same
            // pattern as the search dialog. Doesn't apply on desktop, where this
            // same markup is just the regular, always-visible header nav.
            navWrapper.on('keydown', function(e) {
                if(!isMobileNav() || !headerEl.hasClass('active-header')) {
                    return;
                }

                if(e.key === 'Escape' || e.keyCode === 27) {
                    closeMobileNav();
                    return;
                }

                if(e.key !== 'Tab' && e.keyCode !== 9) {
                    return;
                }

                const focusable = navWrapper.find('a, button').filter(':visible');
                const first = focusable.first();
                const last = focusable.last();

                if(e.shiftKey && document.activeElement === first.get(0)) {
                    e.preventDefault();
                    last.focus();
                } else if(!e.shiftKey && document.activeElement === last.get(0)) {
                    e.preventDefault();
                    first.focus();
                }
            });

            const openSubMenu = function(menuItem) {
                menuItem.addClass('is-active');
                menuItem.find('> .header__toggle-sub-menu').addClass('is-active').attr('aria-expanded', 'true');
            };

            const closeSubMenu = function(menuItem) {
                menuItem.removeClass('is-active');
                menuItem.find('> .header__toggle-sub-menu').removeClass('is-active').attr('aria-expanded', 'false');
            };

            menuHeading.each(function() {
                const menuItem = $(this);
                const toggleBtn = menuItem.find('> .header__toggle-sub-menu');

                // Mouse: only on non-touch, non-mobile layouts
                menuItem.on('mouseover', function() {
                    if($(window).width() > 1024) {
                        openSubMenu(menuItem);
                    }
                });

                menuItem.on('mouseout', function() {
                    if($(window).width() > 1024) {
                        closeSubMenu(menuItem);
                    }
                });

                // Click and keyboard (Enter/Space, native to <button>) both fire
                // 'click', so this is the single explicit way to open the submenu.
                toggleBtn.on('click', function(e) {
                    e.stopPropagation();
                    if(menuItem.hasClass('is-active')) {
                        closeSubMenu(menuItem);
                    } else {
                        openSubMenu(menuItem);
                    }
                });

                // Close once focus moves fully outside the item, regardless of
                // how it was opened.
                menuItem.on('focusout', function(e) {
                    if(!$.contains(menuItem.get(0), e.relatedTarget)) {
                        closeSubMenu(menuItem);
                    }
                });

                menuItem.on('keydown', function(e) {
                    if(e.key === 'Escape' || e.keyCode === 27) {
                        e.stopPropagation();
                        closeSubMenu(menuItem);
                        toggleBtn.trigger('focus');
                    }
                });
            });
        },

        /**
         * Bottom bar
         */
        __bottomBar: function() {
            const bottomBar = wntrTheme.body.find('.scroll__top-bar');

            $(document).scroll(function() {
                const y = $(this).scrollTop();
                if(y > 800) {
                    bottomBar.addClass('showing');
                } else {
                    bottomBar.removeClass('showing');
                }
            });

            bottomBar.on('click', function() {
                $('html, body').animate({
                    scrollTop: 0
                }, 500);
            });
        },

        /**
         * Slider
         */
        __objectSlider: function() {
            const objectSlider = wntrTheme.body.find('.slider');
            if(objectSlider.length) {
                objectSlider.slick({
                    dots: true,
                    arrows: false,
                    infinite: true,
                    speed: 500,
                    autoplay: true,
                    autoplaySpeed: 7000,
                    slidesToShow: 1,
                    centerMode: true,
                });

                const pauseToggle = objectSlider.siblings('.slider__toggle-autoplay');
                pauseToggle.on('click', function() {
                    const btn = $(this);
                    const isPaused = btn.hasClass('is-paused');

                    if(isPaused) {
                        objectSlider.slick('slickPlay');
                    } else {
                        objectSlider.slick('slickPause');
                    }

                    btn.toggleClass('is-paused', !isPaused).attr('aria-pressed', String(!isPaused));
                    btn.find('.sr-only').text(isPaused ? 'Pausa bildspel' : 'Spela upp bildspel');
                });
            }
        },


        /**
         * Search toggle
         */
        __toggleSearch: function() {
            const searchBtn = wntrTheme.body.find('.header__search-btn');
            const body = wntrTheme.body;
            const searchWrapper = wntrTheme.body.find('.header__search-wrapper');
            const searchCloseBtn = wntrTheme.body.find('.header__close-search');
            const searchInput = wntrTheme.body.find('.header__search-input');

            const openSearch = function() {
                searchWrapper.addClass('active').removeAttr('inert');
                searchBtn.attr('aria-expanded', 'true');
                body.addClass('overlay');
                searchInput.focus();
            };

            const closeSearch = function() {
                searchWrapper.removeClass('active').attr('inert', '');
                searchBtn.attr('aria-expanded', 'false');
                body.removeClass('overlay');
                searchBtn.focus();
            };

            $(document).mouseup(function(e) {
                // if the target of the click isn't the container nor a descendant of the container
                if(searchWrapper.hasClass('active') && !searchWrapper.is(e.target) && searchWrapper.has(e.target).length === 0) {
                    closeSearch();
                }
            });

            searchBtn.on('click', openSearch);
            searchCloseBtn.on('click', closeSearch);

            // Trap focus inside the search dialog while it's open, since it's
            // rendered as an overlay on top of the rest of the page.
            searchWrapper.on('keydown', function(e) {
                if(e.key === 'Escape' || e.keyCode === 27) {
                    closeSearch();
                    return;
                }

                if(e.key !== 'Tab' && e.keyCode !== 9) {
                    return;
                }

                const focusable = searchWrapper.find('input, button').filter(':visible');
                const first = focusable.first();
                const last = focusable.last();

                if(e.shiftKey && document.activeElement === first.get(0)) {
                    e.preventDefault();
                    last.focus();
                } else if(!e.shiftKey && document.activeElement === last.get(0)) {
                    e.preventDefault();
                    first.focus();
                }
            });
        },
    };

    $(document).ready(wntrTheme.init);
})(jQuery);